export default {
    game_buy_book_bonus: 'a1.x4170',
    game_buy_book_owner: 'a1.x4110',
    game_buy_book_payment: 'a1.x4120',
    game_buy_book_external_payment: 'a1.x4160',
}